import type { EntryMeta } from '~/types'
import Gallery from '~/components/gallery/Gallery'
import type { MediaPath } from '~/generated/media'

const cover = 'dr/20161231_131023.jpg' satisfies MediaPath
const a = 'dr/20170102_171209.jpg' satisfies MediaPath
// TODO: replace placeholder images with real 2023 photos

export const meta: EntryMeta = {
	slug: '2023',
	name: '2023',
	excerpt: 'Selected frames',
	tags: ['photography'],
	cover,
	order: 130,
}

export default function Year2023() {
	return (
		<>
			<p>A year in frames.</p>
			<Gallery
				items={[
					{ src: cover, alt: '2023' },
					{ src: a, alt: '2023' },
				]}
			/>
		</>
	)
}
